// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__XRnee","divider--primary":"styles_divider--primary__2EvLJ","divider--verticaal":"styles_divider--verticaal__4j0xK"};